/*
  This file should contain only global constants.
*/

export const CRYSTAL_BALL_DEMO_VIDEO =
  "https://chartec-core-public.s3.amazonaws.com/crystal_ball_demo_video/CORE_Crystal_Ball-Tutorial.mp4";
export const CRYSTAL_BALL_DEMO_VIDEO_SD =
  "https://chartec-core-public.s3.amazonaws.com/crystal_ball_demo_video/sd_CORE_Crystal_Ball-Tutorial.mp4";

export const JWPLAYER_SCRIPT =
  "https://content.jwplatform.com/libraries/j7QXJiBq.js";

export const MONTHS_LONG = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const DAYS_LONG = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday"
]


// WEBPACK FOOTER //
// ./app/javascript/constants.ts